<template>
  <div>
    <h2 class="page-header__title" v-bind:style="{ 'background-color': gbColor }">
      {{ pageTitle }}
    </h2>
    <v-container>
      <v-row>
        <div class="d-flex justify-end">
          <router-link v-show="isSubmit" to="/cart" custom v-slot="{ navigate }">
            <v-btn class="ma-2" color="blue lighten-2" dark @click="navigate">
              カートを見る
              <v-icon dark right> mdi-cart </v-icon>
            </v-btn>
          </router-link>
          <LoginDialog v-show="isShowLoginButton" />
          <LogoutDialog v-show="isShowLoginButton" />
        </div>
      </v-row>
      <v-row>
        <div class="d-flex justify-end">
          <p class="mx-5 text-caption">ようこそ {{ partnerName }} さん</p>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LoginDialog from 'vues/shopping-order/components/parts/LoginDialog';
import LogoutDialog from 'vues/shopping-order/components/parts/LogoutDialog';

export default {
  components: {
    LoginDialog,
    LogoutDialog,
  },
  computed: {
    /**
     * カート商品を取得する
     */
    cartItems: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/cartItems'];
      },
    },
    /**
     * タイトルの背景色を取得する
     */
    gbColor: {
      cache: false,
      get() {
        return this.$store.getters['partner/isAuthenticated'] ? '#23398b' : '#ea2006';
      },
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      return this.cartItems.length > 0 && this.isShowCartButton;
    },
    /**
     * パートナー名を取得する
     */
    partnerName: {
      cache: false,
      get() {
        return this.$store.getters['partner/partnerName'];
      },
    },
  },
  data() {
    return {};
  },
  props: {
    isShowCartButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    isShowLoginButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    pageTitle: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
@import 'stylesheets/page.scss';
</style>
